// bootstrap.js
import {Alert,Collapse,Dropdown} from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'
window.bootstrap = {
  Tooltip: {
    VERSION: "5"
  }
}